const doc = [({"en":({"adminConstantHotelInventoryStatus":({"deleted":"Deleted", "onSale":"On Sale", "saleStopped":"stop selling"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;